module.exports = __webpack_public_path__ + "static/media/background.8a814aa8.jpg";